'use client';

import type { CaptureResult } from 'posthog-js';
import type { PostHog } from 'posthog-js/react';
import type { ReactNode } from 'react';

import { posthog } from 'posthog-js';
import { PostHogProvider as InitialPostHogProvider } from 'posthog-js/react';
import { useEffect } from 'react';

declare global {
    interface Window {
        posthog: PostHog;
    }
}

export const PostHogProvider = ({ children }: { children: ReactNode }) => {
    useEffect(() => {
        if (process.env.REACT_APP_POSTHOG_PROJECT_API_KEY) {
            posthog.init(process.env.REACT_APP_POSTHOG_PROJECT_API_KEY, {
                api_host: 'https://eu.i.posthog.com',
                before_send: (
                    event: CaptureResult | null
                ): CaptureResult | null => {
                    if (event?.properties?.$current_url) {
                        const parsed = new URL(event.properties.$current_url);
                        const parsedHash = parsed.hash.replace('#/', '');

                        // Send HashRouter paths without # to PostHog
                        // ? Reference: https://posthog.com/tutorials/hash-based-routing
                        if (parsedHash) {
                            event.properties.$pathname = `${parsed.pathname}${parsedHash}`;
                        }
                    }
                    return event;
                },
                autocapture: false,
                defaults: '2025-05-24',
            });

            if (!window.posthog) {
                window.posthog = posthog;
            }
        }
    }, []);

    return (
        <InitialPostHogProvider client={posthog}>
            {children}
        </InitialPostHogProvider>
    );
};
